import axios from 'axios'
import state from './state'

import { handleBridgeError } from './bridge/api'
import { handleUnauthenticatedError } from './auth/api'

import { toastController } from '@modus/ionic-vue'

const instance = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_API_URL,
})
let allowedToFail= false

function beforeRequest(config) {
  const token = state.getters.accessToken
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}

function onSuccess(response) {
  if(response.data) {
    const data = response.data

    if(data.message) {
      toastController.create({
        message: data.message,
        color: 'success',
        duration: 3000
      })
      .then(toast => toast.present())
    }
  }

  return response
}

function onError(error) {
  if(allowedToFail){
    allowedToFail = false
    return Promise.reject(error)
  }
  console.error(error)

  if(error.response && error.response.data) {
    const data = error.response.data

    if(data.message) {
      toastController.create({
        message: data.message,
        color: 'danger',
        duration: 3000
      })
      .then(toast => toast.present())
    }
  }

  return Promise.reject(error)
}

instance.interceptors.request.use(beforeRequest)
instance.interceptors.response.use(undefined, handleUnauthenticatedError)
instance.interceptors.response.use(undefined, handleBridgeError)
instance.interceptors.response.use(onSuccess, onError)

// Allow one request to fail without toast or exception
instance.allowFailure = function(){
  allowedToFail = true
  return instance
}

export default instance
